import { getItem, setItem, deleteItem } from '@src/utils/storage'

const KEY_NAME = 'NOTIFICATION_TS'

export const getNotificationTimestamp = () => getItem(KEY_NAME)

export const setNotificationTimestamp = (timestamp: string) => setItem(KEY_NAME, timestamp)

export const deleteNotificationTimestamp = () => deleteItem(KEY_NAME)
